import type { RiskMatrixData } from '../../../@types/risk-matrix-field';

export interface RiskRatingBaseState {
  riskMatrixCells: Array<RiskMatrixData>;
  riskRatingId?: number;
  displayValue?: string;
  selectedDescription?: string;
  currentDescription?: string;
}

export const RiskRatingBaseActionType = {
  SetRiskMatrixCells: 0,
  UpdateRiskRatingProperties: 1,
  UpdateCurrentDescription: 2,
} as const;
export type RiskRatingBaseActionType = (typeof RiskRatingBaseActionType)[keyof typeof RiskRatingBaseActionType];

interface RiskRatingBaseReducerAction {
  type: RiskRatingBaseActionType;
  riskMatrixCells?: Array<RiskMatrixData>;
  riskRatingId?: number;
  displayValue?: string;
  selectedDescription?: string;
  currentDescription?: string;
}

export default function reducer(state: RiskRatingBaseState, action: RiskRatingBaseReducerAction): RiskRatingBaseState {
  switch (action.type) {
    case RiskRatingBaseActionType.SetRiskMatrixCells:
      if (action.riskMatrixCells) {
        return {
          ...state,
          riskMatrixCells: action.riskMatrixCells,
        };
      }
      return { ...state };

    case RiskRatingBaseActionType.UpdateRiskRatingProperties:
      if (action.riskRatingId && action.displayValue && action.selectedDescription) {
        return {
          ...state,
          riskRatingId: action.riskRatingId,
          displayValue: action.displayValue,
          selectedDescription: action.selectedDescription,
        };
      }
      return { ...state };

    case RiskRatingBaseActionType.UpdateCurrentDescription:
      if (action.currentDescription) {
        return {
          ...state,
          currentDescription: action.currentDescription,
        };
      }
      return { ...state };

    default:
      return state;
  }
}
